module.exports = __webpack_public_path__ + "static/images/high-five.140972d3fba01c510fa48758527d91a0.svg";